
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import SmashableMarkerRocks from "../../editor/entity-markers/SmashableMarkerRocks";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerStack3 from "../../editor/platform-markers/cave/PlatformMarkerStack3";
import TrapMarkerTorch from "../../editor/trap-markers/cave/TrapMarkerTorch";
import PlatformMarkerStack1 from "../../editor/platform-markers/cave/PlatformMarkerStack1";
import PlatformMarkerPlatLong from "../../editor/platform-markers/cave/PlatformMarkerPlatLong";
import PlatformMarkerPlatMid from "../../editor/platform-markers/cave/PlatformMarkerPlatMid";
import PlatformMarkerPlatMini from "../../editor/platform-markers/cave/PlatformMarkerPlatMini";
import PlatformMarkerRock from "../../editor/platform-markers/cave/PlatformMarkerRock";
import PlatformMarkerGroundLava from "../../editor/platform-markers/cave/PlatformMarkerGroundLava";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerPlat from "../../editor/platform-markers/cave/PlatformMarkerPlat";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveChunk3 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? -381.58257912127925, y ?? 178.22467347422582);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 233, 368);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 6413, 368);
    this.add(editor_bounds_right);

    // smashableMarkerRocks_2
    const smashableMarkerRocks_2 = new SmashableMarkerRocks(scene, 2158, 115);
    this.add(smashableMarkerRocks_2);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2179, -167);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 2727, 233);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2604, 236);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2867, 236);
    this.add(gemMarker_3);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 2840, -169);
    this.add(gemMarker_12);

    // platformMarkerStack_12
    const platformMarkerStack_12 = new PlatformMarkerStack3(scene, 5691, 265);
    this.add(platformMarkerStack_12);

    // platformMarkerStack_13
    const platformMarkerStack_13 = new PlatformMarkerStack3(scene, 6042, 261);
    this.add(platformMarkerStack_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 4677, 230);
    this.add(gemMarker_14);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 5124, -171);
    this.add(gemMarker_15);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 5002, 164);
    this.add(gemMarker_16);

    // trapMarkerTorch_6
    const trapMarkerTorch_6 = new TrapMarkerTorch(scene, 3510, -157);
    this.add(trapMarkerTorch_6);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 2382, -169);
    this.add(gemMarker_4);

    // gemMarker_17
    const gemMarker_17 = new SmallGemMarker(scene, 3297, -149);
    this.add(gemMarker_17);

    // gemMarker_18
    const gemMarker_18 = new SmallGemMarker(scene, 1806, -10);
    this.add(gemMarker_18);

    // gemMarker_20
    const gemMarker_20 = new SmallGemMarker(scene, 1015, 171);
    this.add(gemMarker_20);

    // gemMarker_22
    const gemMarker_22 = new SmallGemMarker(scene, 2021, 242);
    this.add(gemMarker_22);

    // gemMarker_23
    const gemMarker_23 = new SmallGemMarker(scene, 540, 240);
    this.add(gemMarker_23);

    // gemMarker_24
    const gemMarker_24 = new SmallGemMarker(scene, 3707, -154);
    this.add(gemMarker_24);

    // platformMarkerStack_7
    const platformMarkerStack_7 = new PlatformMarkerStack1(scene, 5318, 299);
    this.add(platformMarkerStack_7);

    // gemMarker_25
    const gemMarker_25 = new SmallGemMarker(scene, 5322, 217);
    this.add(gemMarker_25);

    // gemMarker_26
    const gemMarker_26 = new SmallGemMarker(scene, 5797, 68);
    this.add(gemMarker_26);

    // gemMarker_27
    const gemMarker_27 = new SmallGemMarker(scene, 5243, -176);
    this.add(gemMarker_27);

    // platformMarkerPlatLong
    const platformMarkerPlatLong = new PlatformMarkerPlatLong(scene, 3502, -76);
    this.add(platformMarkerPlatLong);

    // platformMarkerPlatMid
    const platformMarkerPlatMid = new PlatformMarkerPlatMid(scene, 2285, -86);
    this.add(platformMarkerPlatMid);

    // platformMarkerPlatMini
    const platformMarkerPlatMini = new PlatformMarkerPlatMini(scene, 1802, 72);
    this.add(platformMarkerPlatMini);

    // platformMarkerRock
    const platformMarkerRock = new PlatformMarkerRock(scene, 1014, 286);
    this.add(platformMarkerRock);

    // platformMarkerGroundLava
    const platformMarkerGroundLava = new PlatformMarkerGroundLava(scene, 1531, 315);
    this.add(platformMarkerGroundLava);

    // platformMarkerPlatMid_2
    const platformMarkerPlatMid_2 = new PlatformMarkerPlatMid(scene, 5868, 151);
    this.add(platformMarkerPlatMid_2);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 2289, 244);
    this.add(megaGemMarker_2);

    // smashableMarkerRocks
    const smashableMarkerRocks = new SmashableMarkerRocks(scene, 3354, 121);
    this.add(smashableMarkerRocks);

    // platformMarkerPlatMini_5
    const platformMarkerPlatMini_5 = new PlatformMarkerPlatMini(scene, 2840, -87);
    this.add(platformMarkerPlatMini_5);

    // smashableMarkerRocks_1
    const smashableMarkerRocks_1 = new SmashableMarkerRocks(scene, 4548, 108);
    this.add(smashableMarkerRocks_1);

    // gemMarker_28
    const gemMarker_28 = new SmallGemMarker(scene, 332, 238);
    this.add(gemMarker_28);

    // gemMarker_29
    const gemMarker_29 = new SmallGemMarker(scene, 4101, -159);
    this.add(gemMarker_29);

    // platformMarkerPlat_2
    const platformMarkerPlat_2 = new PlatformMarkerPlat(scene, 4560, -85);
    this.add(platformMarkerPlat_2);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 4556, -154);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 3481, 248);
    this.add(megaGemMarker_1);

    // platformMarkerPlat_3
    const platformMarkerPlat_3 = new PlatformMarkerPlat(scene, 5181, -88);
    this.add(platformMarkerPlat_3);

    // platformMarkerGroundLava_1
    const platformMarkerGroundLava_1 = new PlatformMarkerGroundLava(scene, 438, 316);
    this.add(platformMarkerGroundLava_1);

    // platformMarkerGroundLava_2
    const platformMarkerGroundLava_2 = new PlatformMarkerGroundLava(scene, 2158, 315);
    this.add(platformMarkerGroundLava_2);

    // platformMarkerGroundLava_3
    const platformMarkerGroundLava_3 = new PlatformMarkerGroundLava(scene, 2742, 320);
    this.add(platformMarkerGroundLava_3);

    // platformMarkerGroundLava_4
    const platformMarkerGroundLava_4 = new PlatformMarkerGroundLava(scene, 3349, 320);
    this.add(platformMarkerGroundLava_4);

    // platformMarkerGroundLava_5
    const platformMarkerGroundLava_5 = new PlatformMarkerGroundLava(scene, 3938, 308);
    this.add(platformMarkerGroundLava_5);

    // platformMarkerGroundLava_6
    const platformMarkerGroundLava_6 = new PlatformMarkerGroundLava(scene, 4543, 304);
    this.add(platformMarkerGroundLava_6);

    // platformMarkerRock_1
    const platformMarkerRock_1 = new PlatformMarkerRock(scene, 4999, 281);
    this.add(platformMarkerRock_1);

    // platformMarkerPlatMini_6
    const platformMarkerPlatMini_6 = new PlatformMarkerPlatMini(scene, 4103, -84);
    this.add(platformMarkerPlatMini_6);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 3922, 215);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 3799, 218);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 4062, 218);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 1522, 228);
    this.add(gemMarker_8);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 1399, 231);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 1662, 231);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 4419, 224);
    this.add(gemMarker_11);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 329, 278);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 3797, 271);
    this.add(checkpointMarker_1);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 5733, 101);
    this.add(checkpointMarker_2);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // smashableMarkerRocks_2 (components)
    const smashableMarkerRocks_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_2);
    smashableMarkerRocks_2SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerRocks (components)
    const smashableMarkerRocksSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks);
    smashableMarkerRocksSimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerRocks_1 (components)
    const smashableMarkerRocks_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerRocks_1);
    smashableMarkerRocks_1SimpleBreakableBlocker.allowedCharacter = "grizz";

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
